/**
 * Primary JS file for victaulic.
 *
 * Localized vars available as victaulicThemeVars.
 */

const victaulicTheme = {
  init() {
    victaulicTheme.clickEvents();
    victaulicTheme.themeToggleBox();
    victaulicTheme.mobileMenu();
    victaulicTheme.topicsFiltering();
    victaulicTheme.taxWidgetFilter();
  },

  /**
   * Adds redirect to Taxonomy filter widgets.
   * Applied only for widgets that contains class cf_tax_filter_widget.
   */

  taxWidgetFilter() {
    const element = $(document).find('.cf_tax_filter_widget');
    const getUrl = window.location;
    const baseUrl = getUrl.pathname.split('/')[2];
    const select = element.find('select');
    const title = element.find('.widgettitle').text();

    if (element && select) {
      if (title) {
        select.prepend(`<option value="default" selected>${title}</option>`);
      }

      if (baseUrl) {
        select.val(baseUrl);
      }

      select.on('change', (e) => {
        const currURL = window.location.href.split('?');
        if (e.target.value && e.target.value !== 'default') {
          window.location.href = `${window.location.protocol}//${window.location.host}/projects-market/${e.target.value}/?${currURL[1]}`;
        } else {
          window.location.href = `${window.location.protocol}//${window.location.host}/projects/?${currURL[1]}`;
        }
        e.preventDefault();
      });
    }
  },

  mobilecheck() {
    let check = false;
    ((a) => {
      if (
        /(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
          a,
        )
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
          a.substr(0, 4),
        )
      ) { check = true; }
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  },

  clickEvents() {
    const eventtype = victaulicTheme.mobilecheck() ? 'touchstart' : 'click';

    $('html').on(eventtype, () => {
      $('.toggle-trigger').removeClass('toggle-active');
      $('.box-to-trigger').fadeOut(100);
    });

    $('.js-visibility-toggle').on('click', (event) => {
      event.preventDefault();
      const target = $(event.currentTarget).data('target');

      if (target) {
        const $target = $(target);
        if ($target.length) {
          $target.toggle();
        }
      }
    });
  },

  themeToggleBox() {
    const eventtype = victaulicTheme.mobilecheck() ? 'touchstart' : 'click';
    $('.toggle-trigger').on(eventtype, () => {
      const $this = $(this);
      if (!$this.hasClass('toggle-active')) {
        $('.box-to-trigger').fadeOut(100);
        $this.parent().find('.box-to-trigger').fadeIn(150);
        $('.toggle-trigger').removeClass('toggle-active');
        $this.addClass('toggle-active');
      } else {
        $('.box-to-trigger').fadeOut(100);
        $this.removeClass('toggle-active');
      }
      return false;
    });
  },

  mobileMenu() {
    $('.mobile-menu-trigger').on('click', (event) => {
      event.preventDefault();
      $('body').toggleClass('mobile-menu-active');
    });

    $('#mobile-menu .menu-item-has-children:not(.active) > a').on(
      'click',
      (event) => {
        event.preventDefault();
        $(event.currentTarget).parent().toggleClass('active');
      },
    );

    $('#mobile-menu .menu-item-has-children > a').each((index, element) => {
      const $listItem = $('<li class="menu-item"></li>');
      const $that = $(element);
      let $linkHtml = element.outerHTML;
      const $link = $that.attr('href');
      if ($link !== '#') {
        $linkHtml = $($linkHtml).append(
          ` ${victaulicThemeVars.translations.overview}`,
        );
        $listItem.append($linkHtml);
      }
      $that.parent().find('ul.sub-menu:first').prepend($listItem);
    });
  },

  topicsFiltering() {
    const $topicsFiltering = $('.fl-theme-builder-archive .st-tag-cloud');
    const $bodyClasses = $('body.archive').attr('class');

    if ($topicsFiltering.length) {
      if ($('body.archive').length) {
        // Add active class to the simple tag cloud in order to apply styling.
        const $tagClass = $bodyClasses.match(/tag-\d+/)[0];
        const $tagNumber = parseInt($tagClass.match(/\d+/)[0], 10);
        $topicsFiltering.find(`#tag-link-${$tagNumber}`).addClass('active');
      }

      // Create logic for showing/hiding more topics for the archive topics filtering.
      if ($topicsFiltering.height() > 50) {
        $topicsFiltering.addClass('collapsed');
        $topicsFiltering.prepend(
          '<a href="javascript:;" class="js-mobile-expand-tags">Browse by topics <span class="mdi mdi-chevron-down"></span></a> <a href="javascript:;" class="js-mobile-collapse-tags">Close topics <span class="icon icon-arrow-victaulic-light-gray"><span class="hidden">Open</span></span></a></a>',
        );
        $topicsFiltering.append(
          '<a href="javascript:;" class="js-expand-tags">More Topics <span class="mdi mdi-chevron-down"></span></a> <a href="javascript:;" class="js-collapse-tags"><span class="icon icon-close-victaulic-light-gray"><span class="hidden">Close</span></span></a>',
        );
      }
    }

    $('.js-expand-tags, .js-mobile-expand-tags').on('click', () => {
      $topicsFiltering.removeClass('collapsed');
    });

    $('.js-collapse-tags, .js-mobile-collapse-tags').on('click', () => {
      $topicsFiltering.addClass('collapsed');
    });
  },
};

const mobileResourcesListingTransformReset = () => {
  $('.categories-filter').removeClass('small-resolution');
  $('.vtc-resources').removeClass('small-resolution');
  $('.vtc-resources .vtc-resource-title').off('click');
  return true;
};

const mobileResourcesListingTransform = () => {
  const $bodyHtml = $('html, body');

  // Let's start with this, as the event might be executed on breakpoint change.
  mobileResourcesListingTransformReset();

  if ($(window).width() <= 678) {
    const $stickyNavigation = $('.sticky-navigation');
    // This is a small resolution, let's transform the table into accordion.
    $('.vtc-resources')
      .not('.vtc-cart-collection-table')
      .addClass('small-resolution');

    // Toggle active state for resources items.
    $('.vtc-resources').each((index, element) => {
      const $items = $(element).find('.vtc-resource-title');
      $items.on('click', (event) => {
        event.preventDefault();
        const $this = $(event.currentTarget).parent();
        let $top = 0;

        if ($stickyNavigation.length) {
          $top = $stickyNavigation.height();
        }
        $this.toggleClass('active');
        $this.siblings().removeClass('active');

        $bodyHtml.animate(
          {
            scrollTop: $this.offset().top - $top,
          },
          500,
        );
      });
    });
  }
  return true;
};

const handleRedirects = () => {
  const currentUrl = window.location.pathname + window.location.hash;
  window.pageRedirectsData.forEach((item) => {
    if (item.from === currentUrl) {
      window.location = item.to;
    }
  });
};

const userAgentBodyClass = () => {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    if (ua.indexOf('Trident/7.0') > -1) {
      $('body').addClass('browser_ie nrowser_version_11');
    } else if (ua.indexOf('Trident/6.0') > -1) {
      $('body').addClass('browser_ie nrowser_version_10');
    } else if (ua.indexOf('Trident/5.0') > -1) {
      $('body').addClass('browser_ie nrowser_version_9');
    } else if (ua.indexOf('Trident') > -1) {
      $('body').addClass('browser_ie');
    }
  }
  // legacy implementation, might as well leave in for now.
  if (undefined !== $.browser) {
    if (
      $.browser.msie
      || (!!window.MSInputMethodContext && !!document.documentMode)
    ) {
      $('body').addClass('ie');
    }
  }

  return true;
};

const submenuBodyClass = () => {
  const $hasSubmenu = $('.sticky-navigation');

  if ($hasSubmenu && $hasSubmenu.length > 0) {
    $('body').addClass('has_submenu');
  }
  return true;
};

const mobileSystemCategoriesNavigationReset = () => {
  $('.categories-filter').removeClass('small-resolution, with-nav');
  const $catNav = $(
    '.categories-filter .nav-prev, .categories-filter .nav-next',
  );
  $catNav.off('click');
  $catNav.remove();
};

const mobileSystemCategoriesNavigation = () => {
  // Let's start with this, as the event might be executed on breakpoint change.
  mobileSystemCategoriesNavigationReset();

  if (!$(window).width() <= 678) {
    return;
  }
    // This is a small resolution, let's transform the tabs navigation into slider.
  $('.categories-filter').addClass('small-resolution');

  // Transform to slider each potential tabs block (resources or products lists).
  $('.categories-filter').each((i, el) => {
    const $el = $(el);
    let $items = $el.find('.js-category-filter');
    let index = !$items.length
      ? $el.find('.js-term-filter.active').index()
      : $el.find('.js-category-filter.active').index();

    if (!$items.length) {
      // This is a resources list.
      $items = $el.find('.js-term-filter');
    }

    const minIndex = 0;
    const maxIndex = $items.length - 1;

    if (!$el.hasClass('with-nav') && maxIndex > 0) {
      // Make some navigation only if there are more items.
      $el.addClass('with-nav');

      // Append the navigation arrow.
      $el.prepend(
        '<span class="icon icon-arrow nav-prev"></span> <span class="icon icon-arrow nav-next"></span>',
      );
    }

    if ($el.hasClass('with-nav')) {
      // If the current list should have navigation, let's trigger some events on click.
      $el
        .find('.nav-prev')
        .on('click', () => {
          index -= 1;
          // Circle back.
          index = index < minIndex ? maxIndex : index;
          $($items[index]).trigger('click');
        });
      $el
        .find('.nav-next')
        .on('click', () => {
          index += 1;
          // Circle back.
          index = index > maxIndex ? minIndex : index;
          $($items[index]).trigger('click');
        });
    }
  });
};

const mobileMenuReset = () => {
  $('body').removeClass('mobile-menu-active');
  $('#mobile-menu .menu-item').removeClass('active');
  return true;
};

const updateFilterVisibility = (filter, el, classPretext) => {
  const elements = $(el);

  if (filter === 'all') {
    // Display all elements.
    elements.fadeIn();
  } else {
    // Display elements from the selected category.
    elements.filter(`.${classPretext}-${filter}`).show();
    // Hide elements that are not from the selected category.
    elements.not(`.${classPretext}-${filter}`).hide();
  }
};

const onSystemProductFilterClick = (event) => {
  const $this = $(event.currentTarget);
  const $parent = $this.parents('.systems-section:first');
  const filter = $this.data('filter');
  const elements = $parent.find('.vtc-product-box');

  $parent.find('.js-category-filter').removeClass('active');
  $this.addClass('active');

  updateFilterVisibility(filter, elements, 'js-category-filter');
  return true;
};

const onSystemResourceFilterClick = (event) => {
  const $this = $(event.currentTarget);
  const $parent = $this.parents('.systems-extras .resources:first');
  const filter = $this.data('filter');
  const elements = $parent.find('.vtc-resource-item');

  $parent.find('.js-term-filter').removeClass('active');
  $this.addClass('active');

  updateFilterVisibility(filter, elements, 'js-term-filter');
};

const initCategoriesFilters = () => {
  const $resourcesFilters = $('.systems-extras .resources .js-term-filter');

  // Init the system products fiters.
  $('.js-category-filter').on('click', (event) => onSystemProductFilterClick(event));

  // Init the system resources fiters.
  if (typeof $resourcesFilters !== 'undefined') {
    $resourcesFilters.on('click', (event) => onSystemResourceFilterClick(event));

    // Make sure we start with only the first type items listed.
    $('.systems-extras .resources .js-term-filter.active').trigger('click');
  }

  // For the mobile view, the categories lists are rendered differently.
  mobileSystemCategoriesNavigation();
  mobileResourcesListingTransform();
  return true;
};

const onWindowResize = () => {
  mobileSystemCategoriesNavigation();
  mobileResourcesListingTransform();
  mobileMenuReset();
  return true;
};

const hideUabbModal = (e) => {
  e.preventDefault();
  $('.uabb-modal-parent-wrapper').hide();
  return true;
};

const onActionsWrapperClick = (e) => {
  $(e.currentTarget)
    .children('.show-advanced-filters, .hide-advanced-filters')
    .toggleClass('disabled');
  $('.row.secondary').toggleClass('disabled');
  $('.filter-wrapper:not(.principal)').toggleClass('disabled-facet');
};

const initAdvancedFilters = () => {
  const wrapper = $('.actions-wrapper');
  if (wrapper.is(':visible')) {
    wrapper.on('click', (e) => onActionsWrapperClick(e));
  }
};

(() => {

  victaulicTheme.init();

  handleRedirects();
  userAgentBodyClass();
  submenuBodyClass();
  initCategoriesFilters();
  initAdvancedFilters();

  $(window).on('resize', onWindowResize);

  $('.nws-cnf-btn').on('click', (e) => hideUabbModal(e));

})(jQuery);

export default victaulicTheme;
